// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Alert, AlertTitle } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';

export const ImportantNoticeAlert = defineComponent({
  displayName: 'ImportantNoticeAlert',
  useSetup: () => ({}),
  View: () => {
    return (
      <Alert
        icon={<AppIcon icon="Warning" size="lg" color="danger" />}
        severity="warning"
        className="!rounded-lg"
        data-testid="important-notice-alert"
      >
        <AlertTitle>
          <Translation
            i18nKey="onboarding-process-overview.result-and-signature.important-notice.title"
            ns="components"
          />
        </AlertTitle>

        <Translation
          i18nKey="onboarding-process-overview.result-and-signature.important-notice.content"
          ns="components"
          components={{
            ul: <ul className="mt-2 list-inside list-disc space-y-2" />,
            li: <li />,
          }}
          tOptions={{
            interpolation: { escapeValue: false },
          }}
        />
      </Alert>
    );
  },
});
